/* Header cart badge: hidden while the cart is empty, shown with the item count once it has items.
   The theme's cart scripts write the count into the existing element, so this watches that element and toggles
   the .is-empty class. No cart requests are made here. */
(() => {
  const sync = (el) => {
    const count = parseInt(el.textContent, 10);
    el.classList.toggle('is-empty', !(count > 0));
  };

  const watch = (el) => {
    if (el.dataset.badgeWatched) return;
    el.dataset.badgeWatched = '1';
    new MutationObserver(() => sync(el)).observe(el, { childList: true, characterData: true, subtree: true });
    sync(el);
  };

  const scan = () => document.querySelectorAll('.cart-count.h-count').forEach(watch);

  scan();
  document.addEventListener('DOMContentLoaded', scan);
})();
